export const largeWowheadUrl = (image: string) => `https://wow.zamimg.com/images/wow/icons/large/${image}.jpg`
export const smallWowheadUrl = (image: string) => `https://wow.zamimg.com/images/wow/icons/large/${image}.jpg`

export const WowheadIconNames = {
    questionMark: "inv_misc_questionmark"
}
